import axios from "axios";
import { API } from "../config/BackendUrl";
const tokenurl = `${API}/token`;

export const getmarketItem = async () => {
  const config = {
    method: "get",
    url: `${tokenurl}/marketItem`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getNftData = async (tokenId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/uri/${tokenId}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getcreatedToken = async (walletAddress) => {
  const config = {
    method: "get",
    url: `${tokenurl}/createdToken/${walletAddress}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getownedToken = async (walletAddress) => {
  console.log("walletAddress", walletAddress);

  const config = {
    method: "get",
    url: `${tokenurl}/ownedToken/${walletAddress}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getDataFromURI = async (tokenURI) => {
  const config = {
    method: "get",
    url: `${tokenURI}`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return [];
  }
};

export const getIPFS = async (tokenID) => {
  const config = {
    method: "get",
    url: `${tokenurl}/uri/${tokenID}`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return [];
  }
};

export const getHashData = async (tokenId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/transaction/hash/${tokenId}`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return [];
  }
};

export const getTransactionHistory = async (tokenId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/transaction/history/${tokenId}`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return [];
  }
};

export const etherToGwei = (eth) => {
  const gwei = eth * 1000000000000000000;
  return gwei;
  // gweiAmount.toFixed(0)
};

export const GweiToether = (gwei) => {
  const eth = parseFloat(gwei) / 1000000000000000000;
  // return eth;
  // return eth.toFixed(6);
  // gweiAmount.toFixed(0)
  // Check if the length of decimal places is greater than 6
  const [integerPart, decimalPart] = eth.toString().split(".");
  if (decimalPart && decimalPart.length > 6) {
    return eth.toFixed(6); // Limit to 6 decimal places
  }

  return eth.toString(); // Return as is if <= 6 decimals
};

export const fetchEthPrice = async (value) => {
  try {
    const response = await axios.get(
      "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd"
    );
    const price = response.data.ethereum.usd;
    const eth = value / 1000000000000000000;
    return price * eth;
  } catch (error) {
    console.error("Error fetching ETH price:", error);
  }
};

// export const fetchEthPriceToUSDT = async (value) => {
//   try {
//     const response = await axios.get(
//       "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd"
//     );
//     const price = response.data.ethereum.usd;
//     const eth = value;
//     return price * eth;
//   } catch (error) {
//     console.error("Error fetching ETH price:", error);
//   }
// };

export const fetchEthPriceToUSDT = async (value) => {
  try {
    const response = await axios.get(
      "https://min-api.cryptocompare.com/data/price",
      {
        params: {
          fsym: "ETH", // Base currency (ETH)
          tsyms: "USD", // Target currency (USD)
          api_key:
            "64339c1ec3d3699ea0d155d38d969d3aa6dea56217f89a4ea4201feea68cff78",
        },
      }
    );
    const price = response.data.USD;
    return (price * value).toFixed(2);
  } catch (error) {
    console.error("Error fetching ETH price:", error);
  }
};

const getAuthToken = async () => {
  const res = await axios.get(
    "https://www.universal-tutorial.com/api/getaccesstoken",
    {
      headers: {
        Accept: "application/json",
        "api-token":
          "rQTG2jOZq3eBjkU8HAJ7Vxlf3j6EsWBs7eyYcdApKHjwM5HtzHLlPx2WZXGsv8rl0cE",
        "user-email": "manishfixl@gmail.com",
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
  return res.data.auth_token;
};
// export const getCountries = async () => {
//   const token = await getAuthToken();
//   // console.log(token, "token");
//   const config = {
//       method: "get",
//       url: "https://www.universal-tutorial.com/api/countries",
//       headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//           "Access-Control-Allow-Origin":"*"
//       },
//   };

//   const res = await axios(config);

//   //console.log(res.data, "res.data");
//   return res.data;
// };
export const getCountries = async () => {

  const config = {
    method: "get",
    url: "https://country-state-city-search-rest-api.p.rapidapi.com/allcountries",
    headers: {
      Accept: "application/json",
      // Authorization: `Bearer ${token}`,
      // "Access-Control-Allow-Origin":"*",
      "x-rapidapi-key": "7305697dd3msh2830eaa8135c94bp17fac0jsnd95158386f87",
      "x-rapidapi-host": "country-state-city-search-rest-api.p.rapidapi.com",
    },
  };

  const res = await axios(config);

  return res.data;
};

// export const getState = async (country) => {
//   const token = await getAuthToken();

//   const config = {
//     method: "get",
//     url: `https://www.universal-tutorial.com/api/states/${country}`,
//     headers: {
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   };

//   const res = await axios(config);

//   // console.log(res.data, "res.data states");

//   return res.data;
// };
export const getState = async (country) => {
  const token = await getAuthToken();
console.log("Country", country);

  const config = {
    method: "get",
    url: "https://country-state-city-search-rest-api.p.rapidapi.com/allcountries",
    params:{countrycode: country},
    headers: {
      Accept: "application/json",
      // Authorization: `Bearer ${token}`,
      // "Access-Control-Allow-Origin":"*",

      "x-rapidapi-key": "7305697dd3msh2830eaa8135c94bp17fac0jsnd95158386f87",
      "x-rapidapi-host": "country-state-city-search-rest-api.p.rapidapi.com",
    },
  };

  const res = await axios(config);

  console.log(res.data, "res.data states");

  return res.data;
};
export const getCity = async (state) => {
  const token = await getAuthToken();
  const config = {
    method: "get",
    url: `https://www.universal-tutorial.com/api/cities/${state}`,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios(config);

  // console.log(res.data, "res.data cities");

  return res.data;
};
